import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  background-color: white;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #e0e0e0;
`;

export const ContentWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
`;

export const ResultBox = styled.div`
  width: 100%;
  background-color: #E8F5E9;
  border-radius: 16px;
  padding: 40px 24px;
  text-align: center;
`;

export const Message = styled.div`
  font-size: 16px;
  color: #000;
  margin-bottom: 32px;
  line-height: 1.5;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #000;
`;

export const InfoLabel = styled.span`
  font-weight: 400;
`;

export const InfoValue = styled.span`
  font-weight: 600;
  color: #1FBC70;
  margin-left: 8px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  padding: 0 24px 24px;
  width: 100%;
`;

export const OutlineButton = styled.button`
  flex: 1;
  height: 52px;
  border: 2px solid #1FBC70;
  font-weight: 600;
  font-size: 16px;
  background-color: white;
  border-radius: 12px;
  color: #1FBC70;
  cursor: pointer;

  &:hover {
    background-color: #F0FFF5;
  }

  &:active {
    background-color: #E0F5E8;
  }
`;

export const SolidButton = styled.button`
  flex: 1;
  height: 52px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  background-color: #1FBC70;
  border-radius: 12px;
  color: white;
  cursor: pointer;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    background-color: #159150;
  }
`;
